import { useBreakpointValue } from '@genial/utils';
import { useNavigation } from '@react-navigation/native';
import React, { useCallback } from 'react';

import { useReportGeneratorRequest } from '../../../../store/reportGenerator/request';

import { RequestModalFooter, RequestModalFormStacked } from './shared/RequestModalForm';
import { RequestModalShell } from './shared/RequestModalShell';

export const ReportGeneratorRequestModal: React.FC = () => {
  const navigation = useNavigation();

  const {
    selectedCategory,
    selectedSubCategory,
    selectedDocumentType,
    documentType,
    period,
    referenceDate,
    additionalParameters,
    parameterDefinitions,
    loading,
    documentTypeOptions,
    periodOptions,
    requestPartnerId,
    requestAdvisorId,
    updateDocumentType,
    updatePeriod,
    updateReferenceDate,
    updateAdditionalParameter,
    updateRequestPartnerId,
    updateRequestAdvisorId,
    requestExport,
    canRequestExport,
  } = useReportGeneratorRequest();

  const goBack = useCallback(() => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    }
  }, [navigation]);

  const handleRequestExport = async () => {
    const result = await requestExport();
    if (result === 'success' || result === 'recent-same') {
      goBack();
    }
  };

  const sliderWidth = useBreakpointValue({ base: 1, sm: 0.5, lg: 0.4 });

  const formProps = {
    documentType,
    period,
    referenceDate,
    additionalParameters,
    parameterDefinitions,
    documentTypeOptions,
    periodOptions,
    requestPartnerId,
    requestAdvisorId,
    updateDocumentType,
    updatePeriod,
    updateReferenceDate,
    updateAdditionalParameter,
    updateRequestPartnerId,
    updateRequestAdvisorId,
  };

  return (
    <RequestModalShell
      sliderWidth={sliderWidth ?? 1}
      modalInsideModal={false}
      onDismiss={goBack}
      selectedCategoryLabel={
        selectedSubCategory?.label ??
        selectedDocumentType?.label ??
        selectedCategory?.label ??
        'Nova solicitação'
      }
      footer={
        <RequestModalFooter
          loading={loading}
          canRequestExport={canRequestExport}
          onRequestExport={handleRequestExport}
        />
      }>
      <RequestModalFormStacked {...formProps} />
    </RequestModalShell>
  );
};
